// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const createTimesheetProposalEntryPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  proposal_id: z.coerce.string().describe("Parent proposal ID (uuid)"),
});

export const createTimesheetProposalEntryHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry created successfully
 */
export const createTimesheetProposalEntry201Schema = z.object({
  entry: z.object({
    id: z.number().int(),
    timesheet_proposal_id: z.coerce.string(),
    date: z.string().date(),
    timely_project_id: z.number().int().nullish(),
    timely_label_ids: z.optional(z.array(z.number().int())),
    started_at: z.coerce.string().nullish(),
    ended_at: z.coerce.string().nullish(),
    hour_id: z.number().int().nullish(),
    note: z.coerce.string().nullish(),
    duration_minutes: z.number().int().nullish(),
    resource_id: z.coerce.string().nullish(),
    metadata: z.optional(z.object({})),
    created_at: z.optional(z.coerce.string()),
    updated_at: z.coerce.string().nullish(),
  }),
  operation_metadata: z.object({
    was_reused: z.boolean(),
    action: z.enum(["created_new_entry", "reused_existing_entry"]),
    message: z.coerce.string(),
  }),
});

/**
 * @description timely_project_id is required (absent or null)
 */
export const createTimesheetProposalEntry400Schema = z.object({
  message: z.coerce.string(),
});

/**
 * @description Proposal not found
 */
export const createTimesheetProposalEntry404Schema = z.object({
  message: z.coerce.string(),
});

export const createTimesheetProposalEntryMutationRequestSchema = z.object({
  date: z.optional(z.string().date()),
  timely_project_id: z.number().int().nullish(),
  timely_label_ids: z.optional(z.array(z.number().int())),
  note: z.coerce.string().nullish(),
  duration_minutes: z.number().int().nullish(),
  resource_id: z.coerce.string().nullish(),
  started_at: z.coerce.string().nullish(),
  ended_at: z.coerce.string().nullish(),
});

export const createTimesheetProposalEntryMutationResponseSchema = z.lazy(() => createTimesheetProposalEntry201Schema);
